import React, { useRef, useState } from "react";
import BarcodeGenerator from "../../Component/Barcode/BarcodeGenerator";
import vedantaLogo from "../../assets/Vedanta.png";
import dayjs from "dayjs";
import QRCode from "react-qr-code";
import PrintIcon from "@mui/icons-material/Print";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Box, Button, Grid, IconButton, MenuItem, Select, SelectChangeEvent, Stack, TextField, Typography } from "@mui/material";

const BarCodeMaster:React.FC = () => {
    const printRef = useRef<HTMLDivElement>(null);
    const [formData, setFormData] = useState({
        firstValue: "",
        secondValue: "",
        grossWeight: "",
        netWeight: "",
        selected: "",
    });
    const handlePrint = () => {
        if (printRef.current) {
            const printWindow = window.open("", "_blank");
            if (!printWindow) return;
            printWindow.document.write(
            "<html><head><title>Print</title></head><body>"
            );
            printWindow.document.write(printRef.current.innerHTML);
            printWindow.document.write("</body></html>");
            printWindow.document.close(); // Close the document to trigger the print dialog
            // printWindow.print(); // Directly triggers the print dialog

            // Set a timeout to give the document time to load and then print
            setTimeout(() => {
                printWindow.print(); // Automatically triggers the print dialog
                printWindow.close(); // Close the print window after printing
            }, 500);

            // document.body.innerHTML = originalContents; // Restore the original page content
            // handleUpdateDCStatus();
            setFormData(
                {
                    firstValue: "",
                    secondValue: "",
                    grossWeight: "",
                    netWeight: "",
                    selected: "",
                }
            );
        }
    };

    
      const handleChange = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        const { name, value } = e.target;
        if (name && (typeof value === "string" || typeof value === "number")) {
          setFormData((prev) => ({ ...prev, [name]: value.toString() }));
        }
      };
    
      const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        if (name) {
          setFormData((prev) => ({ ...prev, [name]: value }));
        }
      };

      const handleReset = () => {
        setFormData({ firstValue: "", secondValue: "", grossWeight: "", netWeight: "", selected: "" });
      };
    
    return(
        <>
          <Box display="flex" flexDirection="column" alignItems="center" p={4}>
            <Typography variant="h4" mb={2}>
              QRcode Generator
            </Typography>
            
            <Grid container spacing={2} mb={2} maxWidth={600}>
              {[{ label: "Item ID", name: "firstValue" },
                { label: "Item Value", name: "secondValue" },
                { label: "Gross Weight", name: "grossWeight" },
                { label: "Net Weight", name: "netWeight" }].map(({ label, name }) => (
                <Grid item xs={12} sm={6} key={name}>
                  <TextField
                    label={label}
                    type="number"
                    name={name}
                    value={formData[name as keyof typeof formData]}
                    onChange={(e) => handleChange(e)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Select
                  name="selected"
                  value={formData.selected}
                  onChange={handleSelectChange}
                  displayEmpty
                  fullWidth
                  variant="outlined"
                >
                  <MenuItem value="" disabled>
                    Select Unit
                  </MenuItem>
                  {["rolls", "meter", "nos", "kg"].map((option, i) => (
                    <MenuItem key={i} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>

            <Stack direction="row" spacing={2} mt={2}>
              <IconButton color="primary" onClick={()=>{
                handlePrint();
                // setTimeout(handlePrint,100)
              }} disabled={Object.values(formData).some((value) => !value)}>
                <PrintIcon fontSize="large" />
              </IconButton>
              <Button variant="outlined" color="secondary" onClick={handleReset} startIcon={<RestartAltIcon />}>
                Reset
              </Button>
            </Stack>
          </Box>
            {/* <BarcodeGenerator /> */}
            {formData && (
                <div style={{ display: "none" }}>
                    <div ref={printRef} id="label-print-container">
                        <div
                            style={{
                                padding: "8px",
                                marginTop:0,
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                border: "1px solid black",
                                boxSizing: "border-box",
                                fontFamily: "Arial, sans-serif",
                                transform: "rotate(0deg)", // Ensures landscape mode
                                pageBreakAfter: "always", // Ensures proper printing
                                height: "-webkit-fill-available",
                                width:"100%",
                                position: "relative", // Needed for absolute positioning
                            }}
                        >
                            {/* Left Side - Text Content */}
                            <div style={{ fontSize: "20px", flex: 1,lineHeight: "1.4", width:"55%" }}>
                                <div style={{ margin: 0}}>
                                    <strong>Date:</strong> {dayjs(new Date()).format("YYYY-MM-DD HH:mm")} <br />
                                    <strong>Item:</strong> {formData.firstValue} <br />
                                    <strong>Item Value:</strong> {formData.secondValue} <br />
                                    <strong>Cross weight:</strong> {formData.grossWeight} <br />
                                    <strong>Net weight:</strong> {formData.netWeight} <br />
                                    <strong>Unit:</strong> {formData.selected}
                                </div>
                            </div>

                            {/* Right Side - QR Code and Logo */}
                            <div style={{ textAlign: "center", position: "relative",width:"45%" }}>
                                <img
                                    src={vedantaLogo}
                                    alt="Company Logo"
                                    // style={{ width: "100px", marginBottom: "2px" }}
                                    style={{
                                      // height:"100px",
                                      width: "80px",
                                      position: "absolute",
                                      top: 0,
                                      right: 0,
                                    }}
                                />
                                {/* QR Code */}
                                <div style={{ marginTop: "50px"}}>
                                    <QRCode
                                        value={`${formData.firstValue}-${formData.secondValue}-${formData.grossWeight}-${formData.netWeight}-${formData.selected}`}
                                        size={200}
                                        style={{width:'200px'}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default BarCodeMaster;